import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CostControlPage } from '@/features/commercial/cost-control-page';

const searchSchema = z.object({
  tab: z.enum(['control', 'cash-flow']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/commercial/cost-control')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <CostControlPage projectId={projectId} tab={search.tab} />;
}
